import { ReactNode, Ref, InputHTMLAttributes, useState } from 'react';
import classNames from 'classnames';

import styles from './TextField.module.scss';

type TextFieldProps = InputHTMLAttributes<HTMLInputElement> & {
    label?: string;
    subLabel?: ReactNode;
    leadingIcon?: ReactNode;
    trailingIcon?: ReactNode;
    supportingText?: any;
    error?: boolean;
    ref?: Ref<HTMLInputElement>;
};

const TextField = ({
  label,
  subLabel,
  leadingIcon,
  trailingIcon,
  supportingText,
  error,
  ref,
  onFocus,
  onBlur,
  onChange,
  ...props
}: TextFieldProps) => {
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState(props.defaultValue || '');

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setFocused(true);
    if (onFocus) {onFocus(e);}
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setFocused(false);
    if (onBlur) {onBlur(e);}
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    if (onChange) {onChange(e);}
  };

  return (
    <div
      className={classNames(styles.textFieldContainer, {
        [styles.focused]: focused,
        [styles.filled]: value,
        [styles.error]: error,
      })}
    >
      {label && <label className={classNames(styles.label)}>{label}</label>}
      {subLabel && <label className={classNames(styles.subLabel)}>{subLabel}</label>}

      <div
        className={classNames(styles.inputWrapper, {
          [styles.focused]: focused,
          [styles.filled]: value,
          [styles.error]: error,
        })}
      >
        {leadingIcon && <div className={styles.leadingIcon}>{leadingIcon}</div>}
        <input
          ref={ref}
          className={styles.input}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          {...props}
        />
        {trailingIcon && <div className={styles.trailingIcon}>{trailingIcon}</div>}
      </div>

      {supportingText && (
        <div className={classNames(styles.supportingText, { [styles.errorText]: error })}>
          {Object.values(supportingText.types as Record<string, string>).map((value, index) => (
            <span key={index}>{value}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TextField;
